@if (loading$ | async) {
  <div class="app-page-loading">
    <app-loading-component></app-loading-component>
  </div>
  } @else {
<router-outlet />
  }
